import React from 'react';
import { cn } from '../../lib/utils';

export function Badge({ children, className = '', ...props }) {
  return (
    <span
      className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[var(--bg-recessed)] text-[var(--fg-secondary)] shadow-[var(--border-ring)]', className)}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
